/**
 * Push an event (and optional data) onto the dataLayer.
 */
export function pushDataLayer(event: string, data?: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

/**
 * Forward consent state to Google Consent Mode v2.
 * The initial default-deny AND gtag('config', ...) for GA4 + Google Ads
 * are set synchronously in index.html so the tag is detectable and
 * cookieless pings flow even before the user accepts. This function
 * only sends the "consent update" after the banner interaction —
 * gtag.js then unlocks cookies/full data per granted categories.
 */
export function updateConsent(analytics: boolean, marketing: boolean): void {
  window.dataLayer = window.dataLayer || [];

  // Ensure gtag helper exists (defined in index.html)
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      // gtag.js erwartet ein arguments-Objekt (array-like), kein echtes Array
      // eslint-disable-next-line prefer-rest-params
      (window.dataLayer as unknown[]).push(arguments as unknown as Record<string, unknown>);
    } as Window["gtag"];
  }

  window.gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });

  pushDataLayer("consent_update");
}

// Type augmentation
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: unknown[]) => void;
  }
}
